<template>
  <!-- Error Modal -->
  <div
    id="errorModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      style="max-width:700px !important"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            v-if="isEditRoute"
            id="errorModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.ERROR_PRODUCT_UPDATE') }}
          </h5>
          <h5
            v-else
            id="errorModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.ERROR_PRODUCT_CREATION') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div class="alert alert-danger">
            <p id="errorModalMsg" />
          </div>
          <div>
            <ul
              v-if="$store.state.products.violations"
            >
              <li
                v-for="violation in $store.state.products.violations"
                :key="violation.name"
              >
                {{ violation.name.toUpperCase() }}
                <ul>
                  <li
                    v-for="subViolation in violation.violations"
                    :key="subViolation.code"
                  >
                    {{ paramFormatter(subViolation.name) }} : {{ subViolation.message }}
                  </li>
                </ul>
              </li>
            </ul>
            <div v-else-if="description">
              <ul>
                <li>
                  {{ description }}
                </li>
              </ul>
            </div>
            <div v-else>
              --
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { Modal } from 'bootstrap'
  export default {
    components: {
    },
    props: {
    },
    data () {
      return {
        description: null
      }
    },
    computed: {
    // Check if the route name contains 'edit'
      isEditRoute() {
        return this.$route.name.includes('edit');
      }
    },
    created () {
    },

    methods: {
      showError (msg, description) {
        if (this.isEditRoute) {
          msg += '_UPDATE'
        }
        let errorModal = new Modal(document.getElementById('errorModal'))
        errorModal.show()
        document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
        if (description) {
          this.description = description
        }
      },

      paramFormatter (param) {
        let formattedParam = ''
        formattedParam += param.substring(0, 3).toUpperCase()
        formattedParam += '-' + param.substring(3, param.length)
        return formattedParam
      }
    }
  }
  </script>

  <style scoped lang="scss">

  </style>
